import { Component, inject } from '@angular/core';
import { ToastModule } from 'primeng/toast';
import { ProbationNotificationBodyComponent } from './body/probation-notification-body.component';
import { ButtonModule } from 'primeng/button';
import {
  probationNotificationMessageKey,
  probationNotificationStorageKey
} from '../../constants/notification.constants';
import { MessageService } from 'primeng/api';
import { environment } from 'src/config/environments/environment';
import {
  ReminderTimeDefaults,
  ReminderTimeFactory,
  TimeReminder
} from '../../utils/time/reminder';

@Component({
  selector: 'pp-probation-notifications',
  imports: [ToastModule, ProbationNotificationBodyComponent, ButtonModule],
  templateUrl: 'probation-notifications.component.html',
  styles: `
  :host {
    --p-toast-width: 36rem;
  }
`
})
export class ProbationNotificationsComponent {
  messageService: MessageService = inject<MessageService>(MessageService);
  show1Min: boolean = environment.enableProbation1MinDismiss;
  defaultReminders = ReminderTimeDefaults;

  closeAndRemind(reminder: TimeReminder): void {
    const nextNotificationTime: Date = ReminderTimeFactory.create(reminder);
    localStorage.setItem(
      probationNotificationStorageKey,
      nextNotificationTime.toISOString()
    );
    this.messageService.clear(probationNotificationMessageKey);
  }
}
